export default __webpack_public_path__ + "static/media/Illustration.710f9408.svg";